// Se carga desde la página del quiz y desde la ventana emergente: el bloque evita
// declarar la clase dos veces (antes la segunda carga lanzaba SyntaxError).
if (!customElements.get('jarbar-quiz')) {
class JarbarQuiz extends HTMLElement {
    connectedCallback() {
      this.questions = [...this.querySelectorAll('[data-quiz-question]')];
      this.result = this.querySelector('[data-quiz-result]');
      this.progress = this.querySelector('[data-quiz-progress]');
      this.step = this.querySelector('[data-quiz-step]');
      this.fallback = this.querySelector('.jb-quiz__fallback');
      if (!this.questions.length) return;

      this.classList.add('jb-quiz--interactive');
      this.reset();

      this.querySelectorAll('form').forEach((form) => {
        form.addEventListener('submit', () => {
          const card = form.closest('[data-quiz-card]');
          if (card) this.recordarKit(card.dataset.quizCard);
        });
      });

      const kit = this.kitRecordado();
      if (this.volvioDeEnviar() && kit && this.scores[kit] !== undefined) {
        this.show(kit);
        const card = this.result.querySelector(`[data-quiz-card="${kit}"]`);
        card?.querySelector('.jb-quiz__form')?.classList.add('jb-quiz__form--enviado');
        // Registro del quiz: lo recoge el píxel personalizado y lo manda a GA4 como generate_lead.
        // Solo una vez: el kit recordado se borra justo abajo.
        try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('jb_lead_quiz', { kit }); } catch (e) {}
        setTimeout(() => this.scrollIntoView({ block: 'start', behavior: 'smooth' }), 50);
        try { sessionStorage.removeItem('jb-quiz-kit'); } catch (e) {}
      }

      this.addEventListener('click', (event) => {
        const answer = event.target.closest('[data-quiz-answer]');
        if (answer) this.answer(answer);
        if (event.target.closest('[data-quiz-restart]')) this.reset();
      });
    }

    // Al enviar el correo la página recarga y el quiz volvía a la pregunta 1,
    // con el navegador saltando al pie. Ahora se guarda el kit antes de enviar
    // y, al volver, se muestra ese resultado con la confirmación.
    recordarKit(kit) {
      try { sessionStorage.setItem('jb-quiz-kit', kit); } catch (e) {}
    }

    kitRecordado() {
      try { return sessionStorage.getItem('jb-quiz-kit'); } catch (e) { return null; }
    }

    volvioDeEnviar() {
      const q = new URLSearchParams(location.search);
      return q.get('customer_posted') === 'true' || q.get('quiz') === 'gracias';
    }

    reset() {
      this.scores = { digestivo: 0, relajante: 0, energizante: 0, temporada: 0 };
      this.firstAnswer = null;
      this.current = 0;
      this.result.hidden = true;
      this.result.querySelectorAll('[data-quiz-card]').forEach((card) => (card.hidden = true));
      this.questions.forEach((question, index) => (question.hidden = index !== 0));
      if (this.progress) this.progress.hidden = false;
      if (this.fallback) this.fallback.hidden = false;
      this.updateProgress();
    }

    updateProgress() {
      if (this.step) this.step.textContent = Math.min(this.current + 1, this.questions.length);
    }

    answer(button) {
      const kit = button.dataset.quizAnswer;
      if (this.scores[kit] === undefined) return;
      this.scores[kit] += 1;
      if (button.dataset.first === 'true') this.firstAnswer = kit;

      this.questions[this.current].hidden = true;
      this.current += 1;

      if (this.current < this.questions.length) {
        this.questions[this.current].hidden = false;
        this.updateProgress();
        this.questions[this.current].querySelector('[data-quiz-answer]')?.focus();
        return;
      }

      this.show(this.winner());
    }

    winner() {
      const top = Math.max(...Object.values(this.scores));
      const tied = Object.keys(this.scores).filter((kit) => this.scores[kit] === top);
      if (tied.length === 1) return tied[0];
      // Empate: manda la respuesta de la pregunta 1
      return tied.includes(this.firstAnswer) ? this.firstAnswer : tied[0];
    }

    show(kit) {
      const card = this.result.querySelector(`[data-quiz-card="${kit}"]`);
      if (!card) return;
      card.hidden = false;
      this.result.hidden = false;
      if (this.progress) this.progress.hidden = true;
      if (this.fallback) this.fallback.hidden = true;
      card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      card.querySelector('.jb-quiz__result-name')?.focus?.();
      document.dispatchEvent(new CustomEvent('jarbar:quiz-result', { detail: { kit } }));
    }
  }

  customElements.define('jarbar-quiz', JarbarQuiz);
}
